// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"0":"81f09a27","202":"d6311f34","274":"8ca5e8a0","755":"0827cb3a","940":"f5f2d117"}[chunkId] + ".chunk.js";
};